import { Platform } from 'react-native'
import * as Sharing from 'expo-sharing'

// Cattura una vista (ViewShot) come PNG e la condivide: foglio di condivisione su mobile, download su web.
export async function shareViewAsImage(viewRef, { fileName, dialogTitle }) {
  if (!viewRef?.current) throw new Error('view non pronta')
  const { captureRef } = await import('react-native-view-shot')
  const uri = await captureRef(viewRef, { format: 'png', quality: 1 })
  if (Platform.OS === 'web') {
    const a = document.createElement('a')
    a.href = uri
    a.download = `${fileName}.png`
    a.click()
  } else {
    await Sharing.shareAsync(uri, { mimeType: 'image/png', dialogTitle, UTI: 'public.png' })
  }
}
